module.exports = __webpack_public_path__ + "static/media/scroll-text.b3954977.svg";